(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@one-chain/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@one-chain/core"], factory);
	else if(typeof exports === 'object')
		exports["plugin-btc"] = factory(require("@one-chain/core"));
	else
		root["onechain"] = root["onechain"] || {}, root["onechain"]["plugin-btc"] = factory(root["@one-chain/core"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 